import { List, MyLetters, MyOfficeLetters, Dispatch, IndexSheet, Received, Destroy, IncomingPendingLetters, OutgoingPendingLetters, InstituteLetters, InstituteLetterDetails } from "../Components/index.js";

export default [
    {
        path: "/reports/letter/office-file/:folder_id",
        component: List,
        name: "report.letter.office-file",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/reports/letter/pending",
        component: MyLetters,
        name: "report.my.letter",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/reports/letter/incoming-pending",
        component: IncomingPendingLetters,
        name: "report.letter.incoming.pending",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/reports/letter/outgoing-pending",
        component: OutgoingPendingLetters,
        name: "report.letter.outgoing.pending",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/reports/letter/office-pending",
        component: MyOfficeLetters,
        name: "report.letter.office.pending",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/reports/letter/index",
        component: IndexSheet,
        name: "report.letter.office.index",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/reports/letter/received",
        component: Received,
        name: "report.letter.office.received",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/reports/letter/dispatch",
        component: Dispatch,
        name: "report.letter.office.dispatch",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/reports/letter/destroy",
        component: Destroy,
        name: "report.letter.office.destroy",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/reports/institute/letters",
        component: InstituteLetters,
        name: "report.institute.letters",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/reports/institute/letter/:institute_id",
        component: InstituteLetterDetails,
        name: "report.institute.letters.details",
        meta: {
            requiresAuth: true,
        },
    },
];
